import React, { Component } from 'react';
import { observer, Provider, inject } from 'mobx-react';
import { autorun } from 'mobx';
import { FloorStore } from './floor.store';
import { FloorComponent } from './floor.component';
import FloorForm from './floor.form';

@inject('livingRoomStore', 'appStore', 'routerStore')
@observer
export class FloorProvider extends Component {
    store;
    currentRoomNum;
    disabledEraZoneAutorun = false;
    disabledRoomAreaAutorun = false;
    disabledHydrateAutorun = false;

    constructor(props) {
        super(props);
        const { livingRoomStore, appStore, routerStore, match } = props,
            { history } = routerStore;

        appStore.setURLProps(match);
        appStore.clearError();

        this.currentRoomNum = parseInt(match.params.num, 10);
        livingRoomStore.currentRoomNum = this.currentRoomNum;

        this.store = new FloorStore({
            appStore,
            currentRoomNum: this.currentRoomNum
        });

        this.form = new FloorForm({
            store: this.store,
            appStore: appStore,
            currentRoomNum: this.currentRoomNum
        });

        this.disposeForm = autorun(() => {
            if (!this.disabledEraZoneAutorun) {
                this.setEraAndZone(appStore);
            }

            if (!this.disabledRoomAreaAutorun) {
                this.setRoomAreaField(appStore);
            }

            if (!appStore.loading && !this.disabledHydrateAutorun) {
                this.hydrateForm(appStore);
            }

            if (this.store.goNext) {
                this.store.goNext = false;
                history.push({ pathname: `/livingroom/${this.currentRoomNum}/ceiling`, state: { transition: 'forward' } });
            }

            this.updateRValueEraField(appStore);
        });
    }

    updateRValueEraField(appStore) {
        if (appStore.rValueEra) {
            this.form.$('rvalueEra').set('value', appStore.rValueEra);
        }
    }

    componentWillUnmount() {
        this.disposeForm();
    }

    /**
     * Update era and zone on all rvalue fields
     * @param appStore
     */
    setEraAndZone(appStore) {
        if (!this.disabledEraZoneAutorun && appStore.era && appStore.zone) {
            this.form.era = appStore.era;
            this.form.zone = appStore.zone;
            this.form.retrofitted2009 = appStore.retrofitted2009 === 'yes';
            this.form.standards2009Compliant = appStore.standards2009Compliant;
            this.form.rValueEra = appStore.rValueEra;

            this.form.setExtraProps({
                era: appStore.era,
                zone: appStore.zone,
                retrofitted2009: appStore.retrofitted2009 === 'yes',
                standards2009Compliant: appStore.standards2009Compliant,
                rValueEra: appStore.rValueEra
            });

            this.disabledEraZoneAutorun = true;
        }
    }

    /**
     * Set the value of the floor area (read-only)
     * @param appStore
     */
    setRoomAreaField(appStore) {
        try {
            let floorArea;

            if (this.currentRoomNum === 1) {
                floorArea = appStore.userData.floorarea.floorarea.area;
            } else {
                floorArea = appStore.userData.floorarea[`room${this.currentRoomNum}`][`room${this.currentRoomNum}area`];
            }

            if (!floorArea || typeof floorArea === typeof undefined) {
                // redirect to floorarea ?
            } else {
                this.form.$('floordetails.floorarea').set('value', floorArea);
                this.disabledRoomAreaAutorun = true;
            }
        } catch (e) {}
    }

    /**
     * hydrate floor form
     * @param appStore
     */
    hydrateForm(appStore) {
        const roomKey = `room${this.currentRoomNum}`;
        if (
            appStore.userData &&
            appStore.userData.rooms &&
            appStore.userData.rooms[roomKey] &&
            appStore.userData.rooms[roomKey].floor
        ) {
            appStore.hydrateFormFields(
                appStore.userData.rooms[roomKey].floor,
                'floor',
                this.form
            );
            this.disabledHydrateAutorun = true;
        }
    }

    render() {
        return (
            <Provider form={this.form} store={this.store}>
                <FloorComponent key='floor' />
            </Provider>
        );
    }
}
